import { GraphQLClient } from "../../../../shared/gql-client";
import { gql } from "@apollo/client";
import * as gqlBuilder from "gql-query-builder";
import { InvoiceFilters } from "../../modules/features/InvoiceTable";

export default class InvoiceService {
  private client: GraphQLClient | null = null;

  setClient(client: GraphQLClient) {
    this.client = client;
  }

  async queryInvoiceData(args: Partial<InvoiceFilters> = {}) {
    if (!this.client) throw new Error("GraphQL client not set");
    const variables: Record<string, { type: string; value: unknown }> = {};
    if (args.status) variables.status = { type: "String", value: args.status };
    if (args.relationId)
      variables.relationId = { type: "ID", value: args.relationId };
    if (args.InStorageFrom)
      variables.inOutStorageFrom = {
        type: "Date",
        value: args.InStorageFrom,
      };
    if (args.InStorageUntil)
      variables.inOutStorageUntil = {
        type: "Date",
        value: args.InStorageUntil,
      };
    const { query, variables: gqlVars } = gqlBuilder.query({
      operation: "invoiceData",
      variables:
        Object.keys(variables).length > 0
          ? variables
          : {
              status: { type: "String", value: "to_invoice" },
            },
      fields: [
        {
          relation: [
            "id",
            "debtor_number",
            "label",
            "invoice_product",
            "invoice_cleaning",
          ],
        },
        {
          summary: ["label", "value"],
        },
        {
          requests: [
            "id",
            "pickup_and_delivery_date",
            "in_out_storage",
            "tireset_cleaning",
            {
              "source(trashed: WITH)": [
                {
                  "... on Tireset": [
                    {
                      "car(trashed: WITH)": ["licence", "label"],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    });
    return this.client.query("invoiceData", gql(query), gqlVars);
  }

  async exportInvoiceData(args: {
    status: string;
    relationId?: string;
    invoice: boolean;
    inOutStorageFrom?: string;
    inOutStorageUntil?: string;
    pickupDeliveryDateFrom?: string;
    pickupDeliveryDateUntil?: string;
  }) {
    if (!this.client) throw new Error("GraphQL client not set");
    const variables: Record<string, { type: string; value: unknown }> = {
      status: { type: "String", value: args.status },
      relationId: { type: "ID", value: args.relationId },
      invoice: { type: "Boolean", value: args.invoice },
    };
    if (args.inOutStorageFrom)
      variables.inOutStorageFrom = {
        type: "Date",
        value: args.inOutStorageFrom,
      };
    if (args.inOutStorageUntil)
      variables.inOutStorageUntil = {
        type: "Date",
        value: args.inOutStorageUntil,
      };
    if (args.pickupDeliveryDateFrom)
      variables.pickupDeliveryDateFrom = {
        type: "Date",
        value: args.pickupDeliveryDateFrom,
      };
    if (args.pickupDeliveryDateUntil)
      variables.pickupDeliveryDateUntil = {
        type: "Date",
        value: args.pickupDeliveryDateUntil,
      };
    const { query, variables: gqlVars } = gqlBuilder.mutation({
      operation: "InvoiceDataExport",
      variables,
      fields: ["url"],
    });
    return this.client.mutate("InvoiceDataExport", gql(query), gqlVars);
  }
}
